const getVoucherCode = (state) => state.voucher.voucherCode;
const isVoucherActive = (state) => state.voucher.active;

export { getVoucherCode, isVoucherActive };
